import { AnchorModel, Link } from '@bpba/ui-components';

export class SvgData extends AnchorModel {
  icono: string;

  constructor(icono: string, orden: number, titulo?: string, link?: Link, mensaje?: string) {
    super(orden, titulo, link, mensaje);
    this.icono = icono;
  }

  static fromJsonObject(json: any): SvgData {
    const enlace = Link.fromJsonObject(json?.enlace);
    return new SvgData(json.icono, json.orden, json.titulo, enlace);
  }
}
